module.exports = __webpack_public_path__ + "img/kangaroo pocket height.70025b05.png";